import { useParams, Navigate } from "react-router-dom";
import { Loading } from "@/components/shared/Loading";
import { EmptyState } from "@/components/shared/EmptyState";
import { useCommercialWorkspace } from "@/api/hooks";
import { apiErrorMessage } from "@/lib/apiError";

// Aug 2026 IA correction — an Inquiry is never its own page. This route
// (/sales/inquiries/:id) is kept ONLY for deep-linking (old bookmarks,
// notification links minted before this correction, anything that only
// has the inquiry id and not the clientId) — it immediately resolves the
// inquiry's parent customer and lands the user on that customer's page
// with this inquiry pre-selected, never showing a standalone inquiry
// screen. Any caller that already knows the clientId should route
// directly to `/sales/customers/{clientId}?inquiry={inquiryId}` instead —
// see ActionInbox.jsx, Tasks.jsx, Pipeline.jsx, LeadWorkspace.jsx.
export default function InquiryRedirect() {
  const { id } = useParams();
  const { data, isLoading, error } = useCommercialWorkspace(id);

  if (isLoading) return <Loading label="Opening this inquiry's customer page" />;
  if (error || !data?.inquiry?.clientId) {
    return <EmptyState title="Could not open this inquiry" sub={apiErrorMessage(error, "This inquiry could not be resolved to a customer record.")} />;
  }
  return <Navigate to={`/sales/customers/${data.inquiry.clientId}?inquiry=${id}`} replace />;
}
